import { Star } from "lucide-react";

export default function Stars({ rating = 5, size = 14 }) {
  return (
    <div className="flex gap-0.5" data-testid="review-stars">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          strokeWidth={1}
          className={i <= rating ? "fill-vermilion text-vermilion" : "text-faint"}
        />
      ))}
    </div>
  );
}
